import ReactDOM from "react-dom";
import modalStyles from "./modals.module.scss";
import { logout } from "../../utils/reactUtils";
import { useNavigate } from "react-router-dom";
import styles from "./UserModal.module.scss";

function UserModal({ text = "Andrea Napoletano", isOpen, onClose, position }) {
  const navigate = useNavigate();

  const modalStyle = {
    top: position?.top || "6.5%",
    right: position?.right || "0.5%",
    position: "absolute",
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={modalStyles.modal_content} style={modalStyle}>
      <div className={styles.container}>
        {text}
        <button className="button" onClick={() => logout(navigate)}>
          Logout
        </button>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
}

export default UserModal;
